import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextInput,
  PasswordInput,
  Button,
  Title,
  Text,
  Stack,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useAuth } from '@/hooks/useAuth';

export default function Login() {
  const navigate = useNavigate();
  const { login, isLoading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    const success = await login(email, password);

    if (success) {
      notifications.show({
        title: 'Welcome!',
        message: 'You have been logged in successfully.',
        color: 'green',
      });
      navigate('/');
    } else {
      notifications.show({
        title: 'Login Failed',
        message: 'Invalid email or password. Please try again.',
        color: 'red',
      });
    }
  };

  return (
    <div className="login-page">
      <Container size={420} py={80}>
        <Title ta="center" className="login-title">
          Interview Builder
        </Title>
        <Text c="dimmed" size="sm" ta="center" mt={5} mb={30}>
          Internal tool for creating exit interviews
        </Text>

        <Paper withBorder shadow="md" p={30} radius="md">
          <form onSubmit={handleSubmit}>
            <Stack>
              <TextInput
                label="Email"
                placeholder="your@email.com"
                required
                value={email}
                onChange={(e) => setEmail(e.currentTarget.value)}
              />
              <PasswordInput
                label="Password"
                placeholder="Your password"
                required
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
              />
              <Button type="submit" fullWidth mt="md" loading={isLoading}>
                Sign in
              </Button>
            </Stack>
          </form>
        </Paper>
      </Container>
    </div>
  );
}
